import { initErrorReporting } from './errorReporting';

initErrorReporting();
